import React from 'react';
import { IProps as IBlockProps } from './AccordionBlock.interface';
import AccordionBlock from './AccordionBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';

export interface IInputProps {
    heading?: string;
    description?: string;
    items?: {
        id?: string;
        title: string;
        content: string;
    }[];
    className?: string;
    // Allow passthrough of other props, including BlockWrapper props
    // and specific props for the translation context if needed.
    [key: string]: any;
}

const mapInputToProps = (input: IInputProps): IBlockProps => {

    const { heading, description, items, background, className, ...rest } = input;

    return {
        title: heading || undefined,
        description: description || undefined,
        accordionItems: items ? items?.map((item, idx) => ({
            ...item,
            value: item.id || `item-${idx}`,
        })) : [],
        backgroundColor: background || 'white',
        ...rest
    };
};

const BlockTranslation: React.FC<IInputProps> = (inputProps) => {
    return (
        <TranslationComponent
            inputProps={inputProps}
            TargetComponent={AccordionBlock}
            mapProps={mapInputToProps}
        />
    );
};

export default BlockTranslation;
